module.exports = {
  defaultLanguage: 'ru',
  languages: ['ru', 'en'],
};
